import { render, staticRenderFns } from "./PackagesV2.vue?vue&type=template&id=3d3c86df&scoped=true"
import script from "./PackagesV2.vue?vue&type=script&lang=ts"
export * from "./PackagesV2.vue?vue&type=script&lang=ts"
import style0 from "./PackagesV2.vue?vue&type=style&index=0&id=3d3c86df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c86df",
  null
  
)

export default component.exports